const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost';

export async function GetDocuments(idAssignacio: number) {
    try {
        const response = await fetch(`${baseUrl}:8061/metadata/documents/${idAssignacio}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
        });
        if (response.ok) {
            return await response.json();
        }
        return [];
    } catch (error) {
        console.error('Error fetching documents:', error);
        return [];
    }
}

export async function UploadDocument(idAssignacio: number, file: File) {
    const formData = new FormData();
    formData.append('file', file);

    try {
        const response = await fetch(`${baseUrl}:8061/metadata/documents/${idAssignacio}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: formData
        });
        return response.ok;
    } catch (error) {
        console.error('Error uploading document:', error);
        return false;
    }
}
